module.exports = __webpack_public_path__ + "static/media/logo1.de1ae56a.svg";